<script lang="ts">
	import { getFormattedDate } from '@astlai/common/util';
	import type { DocumentOverview } from 'src/types/llm';
	import { t } from './i18n/tranlsator.svelte';

	interface Props {
		doc: DocumentOverview;
	}
	let { doc }: Props = $props();

	function getSubtitle(type: string) {
		const key = `docType.${type}` as Parameters<typeof t>[0];
		const translated = t(key);
		return translated === key ? type : translated;
	}

	const published_date = $derived(doc.res_date || doc.meta?.speech_date);
</script>

<div class="info">
	<span class="title">
		{#if doc.type === 'speech'}Rede von {doc.meta?.speaker}
		{:else if doc.type === 'eu_com_proposal'}Commission Proposal {doc.meta?.com_id}
		{:else if doc.type === 'cla_paragraph'}{doc.meta?.section_id} {doc.res_name}
		{:else}
			{doc.res_name}
		{/if}
	</span>
	{#if doc.type === 'cla_paragraph' || doc.type === 'cla_annex'}
		<span class="subtitle">{doc.res_name}</span>
	{:else}
		<span class="subtitle"
			>{published_date ? getFormattedDate(published_date) + ' | ' : ''}{getSubtitle(doc.type)}
			{doc.meta?.document_id || ''}</span
		>
	{/if}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;
	.info {
		flex: 1 1 auto;
		@include lib.flex-column();
		@include lib.flex-align(center, stretch);
		overflow: hidden;
		text-align: left;
		.title {
			@include lib.ellipsis();
		}
		.subtitle {
			@include lib.ellipsis();
			font-size: 0.75rem;
			color: var(--text-secondary);
		}
	}
</style>
